import React from 'react'
import './Contactme.css'

function Contactme() {
  return (
    
    <div >
      <div className='hero-img2'>
      <div className="heading">
        <h1>CONTACT</h1>
        <p className='animation4'>Lets have a chat.</p>
       
      </div>
      </div>
     
    </div>




  )
}

export default Contactme